import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem, Typography } from '@mui/material';
import apiInstance from '../../services/ServiceApi';

const UbigeoSelector = ({onChange, valoresIniciales = {}, etiqueta}) => {
    const [departamentos, setDepartamentos] = useState([]);
    const [provincias, setProvincias] = useState([]);
    const [distritos, setDistritos] = useState([]);
    const [departamentoSeleccionado, setDepartamentoSeleccionado] = useState(valoresIniciales.departamento?.codigo || '');
    const [provinciaSeleccionada, setProvinciaSeleccionada] = useState(valoresIniciales.provincia?.codigo || '');
    const [distritoSeleccionado, setDistritoSeleccionado] = useState(valoresIniciales.distrito?.codigo || '');

    useEffect(() => {
        const fetchDepartamentos = async () => {
            try {
            const response = await apiInstance.get('/ubigeo/departamentos/');
            setDepartamentos(response.data);
            } catch (error) {
            console.error("Error fetching departamentos", error);
            }
        };

    fetchDepartamentos();
    }, []);

    useEffect(() => {
    const fetchProvincias = async () => {
        if (!departamentoSeleccionado) return;
        try {
        const response = await apiInstance.get(`/ubigeo/provincias/${departamentoSeleccionado}/`);
        setProvincias(response.data);
        setDistritos([]); // Reset distritos
        } catch (error) {
        console.error("Error fetching provincias", error);
        }
    };

    fetchProvincias();
    }, [departamentoSeleccionado]);

    useEffect(() => {
    const fetchDistritos = async () => {
        if (!departamentoSeleccionado || !provinciaSeleccionada) return;
        try {
        const response = await apiInstance.get(`/ubigeo/distritos/${departamentoSeleccionado}/${provinciaSeleccionada}/`);
        setDistritos(response.data);
        } catch (error) {
        console.error("Error fetching distritos", error);
        }
    };

    fetchDistritos();
    }, [departamentoSeleccionado, provinciaSeleccionada]);
    const handleDepartamentoChange = (e) => {
    const codigoSeleccionado = e.target.value;
    const departamentoSeleccionado = departamentos.find(dep => dep.codigo === codigoSeleccionado);
    setDepartamentoSeleccionado(codigoSeleccionado);
    setProvinciaSeleccionada('');
    setDistritoSeleccionado('');
    if (departamentoSeleccionado) {
        onChange({
        departamento: { codigo: departamentoSeleccionado.codigo, name: departamentoSeleccionado.name },
        provincia: {},
        distrito: {}
        });
    }
    };

    const handleProvinciaChange = (e) => {
    const codigoSeleccionado = e.target.value;
    const provinciaSeleccionada = provincias.find(prov => prov.codigo === codigoSeleccionado);

    setProvinciaSeleccionada(codigoSeleccionado);
    setDistritoSeleccionado('');

    if (provinciaSeleccionada) {
        onChange({
        departamento: { codigo: departamentoSeleccionado, name: departamentos.find(dep => dep.codigo === departamentoSeleccionado)?.name },
        provincia: { codigo: provinciaSeleccionada.codigo, name: provinciaSeleccionada.name },
        distrito: {}
    });
    }
    };
  

    const handleDistritoChange = (e) => {
        const codigoSeleccionado = e.target.value;
        const distritoSeleccionado = distritos.find(dist => dist.codigo === codigoSeleccionado);
    
        setDistritoSeleccionado(codigoSeleccionado);
    
        if (distritoSeleccionado) {
        onChange({
            departamento: { codigo: departamentoSeleccionado, name: departamentos.find(dep => dep.codigo === departamentoSeleccionado)?.name },
            provincia: { codigo: provinciaSeleccionada, name: provincias.find(prov => prov.codigo === provinciaSeleccionada)?.name },
            distrito: { codigo: distritoSeleccionado.codigo, name: distritoSeleccionado.name }
        });
        }
    };
  
  return (
    <div>
      {etiqueta && (
        <Typography variant="h6" component="h3" gutterBottom>
          {etiqueta}
        </Typography>
      )}
      <FormControl fullWidth>
        <InputLabel>Departamento</InputLabel>
        <Select
          value={departamentoSeleccionado}
          onChange={handleDepartamentoChange}
          label="Departamento"
        >
          {departamentos.map((dep) => (
            <MenuItem key={dep.codigo} value={dep.codigo}>{dep.name}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth margin="normal">
        <InputLabel>Provincia</InputLabel>
        <Select
          value={provinciaSeleccionada}
          onChange={handleProvinciaChange}
          label="Provincia"
          disabled={!departamentoSeleccionado}
        >
          {provincias.map((prov) => (
            <MenuItem key={prov.codigo} value={prov.codigo}>{prov.name}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth margin="normal">
        <InputLabel>Distrito</InputLabel>
        <Select
          value={distritoSeleccionado}
          onChange={handleDistritoChange}
          label="Distrito"
          disabled={!provinciaSeleccionada}
        >
          {distritos.map((dist) => (
            <MenuItem key={dist.codigo} value={dist.codigo}>{dist.name}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default UbigeoSelector;
